const domainURL = $('body').data('domain');

function uploadPdf() {
    var formData = new FormData();
    var def = $.Deferred();
    var fileContainer = document.getElementById('pdfSource');
    if (fileContainer && fileContainer.files[0] && fileContainer.files[0].type.indexOf("pdf") > -1) {
        formData.append("pdfSource", fileContainer.files[0]);
        $.ajax({
            url: domainURL + "/api/Careers/UploadPdf",
            type: "POST",
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,  // tell jQuery not to process the data
            contentType: false   // tell jQuery not to set contentType
        }).done(function (data) {
            def.resolve(data);
        }).fail(function (data) {
            def.reject(data);
        });
    } else {
        def.resolve()
    }

    return def;
}

export default uploadPdf;
